import React from 'react';
import LegacyVidPlayIcon from '@atlaskit/icon/glyph/vid-play';
import VidPlayIcon from '@atlaskit/icon/core/video-play-overlay';
import { PlayButtonWrapper } from './playButtonWrapper';
import { PlayButtonBackground } from './playButtonBackground';
export var PlayButton = function PlayButton() {
  return /*#__PURE__*/React.createElement(PlayButtonWrapper, null, /*#__PURE__*/React.createElement(PlayButtonBackground, null), /*#__PURE__*/React.createElement(VidPlayIcon, {
    color: "currentColor",
    label: "play",
    LEGACY_size: "large",
    LEGACY_fallbackIcon: LegacyVidPlayIcon
  }));
};